/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  DoctorProfile,
  MyAccessibleClinic,
  MyProfileResponse,
} from "./types/doctorProfile";
import { Visit } from "./types/visit";
import { DexieDbType } from "./types/dexie";
import { notification } from "antd";
import setupAppointmentListener from "../../firestore/get-appointments";
import { LocalPatient } from "./types/patient";
import {
  DocumentData,
  QuerySnapshot,
  serverTimestamp,
  Timestamp,
} from "firebase/firestore";
import { MESSAGE_TYPE } from "./events/types";
import {
  APPOINTMENT_STATUS,
  DateAndTimeConfigForReceipt,
  DISCOUNT_TYPE,
  RECEIPT_TYPE,
  TGetReceiptPdfConfig,
} from "@elixir/types";
import { FirebaseAppointment, OfflineAppointment } from "../../firestore/types";
import { firestoreAppointmentActivityDataObject } from "../../controllers/appointments/appointment-activity";
import { TReceipt } from "../../types/appointment";
import { MassagedDoctorProfile } from "../../receiptOnClient/GeneratePDFOnClient";

interface HeaderReceiptParams {
  doctorName?: string;
  headerText?: string;
  clinicName?: string;
  clinicAddress?: string;
  config?: TGetReceiptPdfConfig;
  data?: TReceipt & {
    doctor?: MassagedDoctorProfile;
    clinicData?: MyAccessibleClinic;
    uhid?: string;
    visit_date?: string;
    gender?: string;
    ageInM?: number;
  };
}

export interface GetBulkAppointmentsParams {
  cid: string;
  oids?: string[];
  startDate: Date;
  endDate: Date;
  archive: boolean;
  status?: APPOINTMENT_STATUS[];
  patient_oid?: string;
}

interface FooterReceiptParams {
  config?: TGetReceiptPdfConfig;
  data?: TReceipt & {
    doctor?: MassagedDoctorProfile;
    clinicData?: MyAccessibleClinic;
    uhid?: string;
    visit_date?: string;
  };
}

interface BodyReceiptParams {
  data: TReceipt & {
    doctor?: MassagedDoctorProfile;
    clinicData?: MyAccessibleClinic;
    uhid?: string;
    visit_date?: string;
    gender?: string;
    ageInM?: number;
  };
}

interface PatientIntroReceiptParams {
  patientInfo: {
    name: string;
    uhid: string;
    gender?: string;
    age?: number;
  };
  appointmentInfo: {
    visit_date: string;
  };
}

export type UpdateAppointmentOnFirestoreArgs = {
  data: Partial<
    Omit<FirebaseAppointment, "aid" | "updated_at" | "created_at">
  > &
    WriteOnlyArgsOnFirestore;
  aid: string;
};

export type UpdateAssessmentOnFirestoreArgs = {
  workflowId: string;
  data: {
    sa_id: string;
    status: string;
  };
  aid: string;
};

export type WriteOnlyArgsOnFirestore = {
  inclusion_ids?: number[];
};

export type CreateAppointmentOnFirestoreArgs = {
  data: Omit<FirebaseAppointment, "updated_at" | "created_at"> &
    WriteOnlyArgsOnFirestore;
  aid: string;
};

export type SendCommunicationProps = {
  data: {
    msg_type: MESSAGE_TYPE;
    receipt_id?: number | null;
  };
  aid: string;
};

export type CreateAppointmentResponse = Promise<FirebaseAppointment>;

class DummyBridge {
  navigate(
    type: "push" | "replace",
    // @ts-ignore
    params
  ): void {
    // @ts-ignore
    return;
  }
  getDoc(): DoctorProfile | undefined {
    // @ts-ignore
    return;
  }

  async getPrintConfig({
    docid,
    clinicId,
    pid,
  }: {
    docid: string;
    clinicId: string;
    pid: string;
  }): Promise<{
    header_html: string;
    footer_html: string;
    header_height: string;
    footer_height: string;
    head_html: string;
    include_pt_details_in_body?: boolean;
    pt_details_html?: string;
    margin_right?: string;
    margin_left?: string;
  }> {
    return {
      header_html: "",
      footer_html: "",
      header_height: "",
      footer_height: "",
      head_html: "",
    };
  }

  async getLocalVisitByIds(ids: string[]): Promise<Visit[]> {
    return [];
  }
  isTreatmentPlanEnabled(): boolean {
    // @ts-ignore
    return;
  }

  async getData(tableName: string): Promise<Partial<unknown> | undefined> {
    return;
  }

  async isInBetaSchedule(): Promise<boolean> {
    return true;
  }

  track(name: string, params?: { [k: string]: string | undefined }): void {
    console.log("MXP DUMMY EVENT", { name, params });
  }

  getRxPrintUrl(id: string): string {
    const fileName = `${id}-review-print.pdf?v=${new Date().getTime()}`;
    return `/${fileName}`;
  }

  getRxSendUrl(id: string): string {
    const fileName = `${id}.pdf?v=${new Date().getTime()}`;
    return `/${fileName}`;
  }

  async isPrintLabelEnabled(): Promise<boolean> {
    return false;
  }

  async printLabelForPatientWithId(_ptLocalId: string): Promise<void> {
    return;
  }

  getIdb(id?: string): DexieDbType {
    return undefined as unknown as DexieDbType;
  }

  getMe(): MyProfileResponse {
    return {
      docs: [
        {
          id: "161368382403778",
          personal: {
            name: {
              f: "vikalp sahni",
              l: "",
            },
            pic: "https://jugaad.s3.amazonaws.com/0cade0e6-d194-4b57-a4e8-3f5fd61694e7.png",
          },
          professional: {
            username: "vikalpsahni",
            clinics: [{ _id: "63dcd048a27092601cf8c5ec" }],
            default_clinic: "63dcd048a27092601cf8c5ec",
            major_speciality: {
              name: "govind",
            },
          },
        },
        {
          id: "161373341988952",
          personal: {
            name: {
              f: "Bhaskar Chaudhary",
              l: "",
            },
            pic: "https://doctoronboarding.s3.amazonaws.com/aa1d4ff5-fae1-4725-b1b4-31e46188cfb9.png",
          },
          professional: {
            username: "bhaskar",
            clinics: [{ _id: "63dcd048a27092601cf8c5ec" }],
            default_clinic: "63dcd048a27092601cf8c5ec",
            major_speciality: {
              name: "govind",
            },
          },
        },
        {
          id: "161419272566611",
          personal: {
            name: {
              f: "Anusheel Singh",
              l: "",
            },
            pic: "https://a.eka.care/doctor-avatar/161419272566611?v=1659701997",
          },
          professional: {
            username: "anusheel",
            clinics: [{ _id: "63dcd048a27092601cf8c5ec" }],
            default_clinic: "63dcd048a27092601cf8c5ec",
            major_speciality: {
              name: "govind",
            },
          },
        },
        {
          id: "161467756044203",
          personal: {
            name: {
              f: "Raghunandan Kapoor",
              l: "",
            },
            pic: "https://doctoronboarding.s3.amazonaws.com/1fc013a1-73af-46a2-98bc-b039d4fd1636.jpg",
          },
          professional: {
            username: "raghunandan",
            clinics: [{ _id: "63dcd048a27092601cf8c5ec" }],
            default_clinic: "63dcd048a27092601cf8c5ec",
            major_speciality: {
              name: "govind",
            },
          },
        },
        {
          id: "167805359211002",
          personal: {
            name: {
              f: "Vishwa Vignesh",
              l: "",
            },
            pic: "https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png",
          },
          professional: {
            username: "dr-vishwa-vignesh-bengaluru",
            clinics: [{ _id: "63dcd048a27092601cf8c5ec" }],
            default_clinic: "63dcd048a27092601cf8c5ec",
            major_speciality: {
              name: "govind",
            },
          },
        },
        {
          id: "168872855236766",
          personal: {
            name: {
              f: "Eka HMIS God",
              l: "",
            },
            pic: "https://cdn.eka.care/vagus/cl2rhhut3000l0sg1fkcghr9j.png",
          },
          professional: {
            username: "dr-eka-hmis-god-spine-surgeon-bengaluru",
            clinics: [{ _id: "63dcd048a27092601cf8c5ec" }],
            default_clinic: "63dcd048a27092601cf8c5ec",
            major_speciality: {
              name: "govind",
            },
          },
        },
      ],
      clinics: [
        {
          id: "63dcd048a27092601cf8c5ec",
          name: "Default Clinic",
          abdm: {
            hfr_id: "IN2910000565",
          },
        },
        {
          id: "6238e18bbe73c0686cc787f1",
          name: "CLinic Number @5",
          abdm: {
            hfr_id: "IN0510000242",
          },
        },
        {
          id: "63dcd063a27092601cf8c5ed",
          name: "Another Clinic",
          abdm: {
            hfr_id: "IN2910000537",
          },
        },
        {
          id: "65df2044e4e6dc001d4e6fa2",
          name: "Test clinic",
          abdm: {
            hfr_id: "IN0510000242",
          },
        },
        {
          id: "65e03fad6934bd001d94108a",
          name: "New HFR Clinic",
          abdm: {
            hfr_id: "IN0510000242",
          },
        },
        {
          id: "65ec283c2d4fe9001d8fd39c",
          name: "Arrakis Clinic",
          abdm: {
            hfr_id: "",
          },
        },
      ],
      business: {
        id: "10000",
      },
      loginmeta: {
        role: "DOCTOR",
        docid: "161419272566611",
        switch: false,
        userid: "161419272566611",
        username: "Anusheel Singh",
        isvalid: true,
      },
      user: {
        aud: "dr",
        "b-id": "10000",
        dob: "1991-01-01",
        "doc-id": "161419272566611",
        exp: 1729262413,
        fn: "Anusheel Singh",
        gen: "U",
        iat: 1729258813,
        "is-d": true,
        "is-d-s": true,
        "is-p": true,
        iss: "a",
        mob: "+919******975",
        oid: "161419272566611",
        p: "PASS__INCLINIC",
        type: 1,
        uuid: "5cc16a5e-21b9-48f5-9222-33149a127de8",
        ln: "govind",
      },
    };
  }

  amIDoctorOnly(): boolean {
    return true;
  }

  canAccessRoute(match: string): boolean {
    return true;
  }

  isAllowed(action: string): boolean {
    return true;
  }

  isAccessAvailable(name: string): boolean {
    return true;
  }

  showAccessDeniedError(): void {
    notification.error({
      message: "Access Denied",
      description: "You do not have access to perform this action",
      duration: 5,
    });
  }

  async isIpdEnabled(): Promise<boolean> {
    return true;
  }

  async showPurchaseEkaCreditsPopover(): Promise<boolean> {
    return true;
  }

  async showNewSignInStrip(): Promise<boolean> {
    return true;
  }

  async shoudlReceiptBeMadeOnLocalHandler(): Promise<boolean> {
    return true;
  }

  setupAppointmentListener = setupAppointmentListener;

  async refreshPatientDirectory(): Promise<void> {
    console.log("Mimicking pt dir fetch");
  }

  async getPatientsByIds(pids: string[]): Promise<LocalPatient[] | undefined> {
    return [];
  }

  async fetchPatientListFromServer(pids: string[]): Promise<void> {
    return;
  }

  async getAllVisitsWithPatientIds(ids: string[]): Promise<Visit[]> {
    return [];
  }

  appointments = {
    create: async ({
      data,
    }: CreateAppointmentOnFirestoreArgs): CreateAppointmentResponse => {
      return {
        ...data,
        created_at: Timestamp.fromDate(new Date()),
        updated_at: Timestamp.fromDate(new Date()),
      };
    },
    update: async (_: UpdateAppointmentOnFirestoreArgs) => {},
    sendCommunication: async (_: SendCommunicationProps): Promise<unknown> => {
      return;
    },
    updateAssement: async (
      _: UpdateAssessmentOnFirestoreArgs
    ): Promise<unknown> => {
      return;
    },
    getAssementIdWorkflow: async (
      aid: string,
      workflowId: string
    ): Promise<{ sa_id: string; status: string } | undefined> => {
      return;
    },
    cancelAllReminders: async (_: { aid: string }): Promise<unknown> => {
      return;
    },
    getLastVisit: async ({
      patientOids,
    }: {
      patientOids: string[];
    }): Promise<QuerySnapshot<DocumentData, DocumentData> | undefined> => {
      return;
    },
    getUpcomingVisit: async ({
      patientOids,
    }: {
      patientOids: string[];
    }): Promise<QuerySnapshot<DocumentData, DocumentData> | undefined> => {
      return;
    },
    get: (_: string): Promise<OfflineAppointment | null> => {
      return Promise.resolve(null);
    },
    async query(props: {
      clinicId: string;
      doctorIds: string[];
      date: Date;
      getArchived?: boolean;
      status?: APPOINTMENT_STATUS[];
      patientOid?: string;
    }): Promise<QuerySnapshot<DocumentData, DocumentData> | undefined> {
      console.log(props);
      return;
    },
  };

  appointmentsV2 = {
    getBulkAppointments: async (
      data: GetBulkAppointmentsParams
    ): Promise<OfflineAppointment[]> => {
      return [];
    },
  };
  firestore = {
    Timestamp: Timestamp,
    serverTimestamp,
  };

  firebase = {
    initAuth: async () => {},
  };

  recordAppointmentActivityInFireStore = {
    recordAppointmentActivityInFS: async (
      appointmentActivityData: firestoreAppointmentActivityDataObject,
      aid: string
    ) => {
      console.log("called from bridge", appointmentActivityData, "and", aid);
    },
    getAppointmentActivityLogs: async (aid: string) => {
      console.log("called to get data from FS, from ELIXIR with aid ——", aid);
    },
  };
  async getAppointmentUrls(aid: string): Promise<{
    guest_link: string;
  } | null> {
    if (!aid) {
      return null;
    }
    return {
      guest_link: "",
    };
  }

  async openCrispChat(
    trackingName: string,
    trackingObject: { [k: string]: string | undefined } = {},
    text: string
  ) {
    console.log(
      "called to open Crisp Chat",
      trackingName,
      trackingObject,
      text
    );
  }

  templar = {
    receipt: {
      getHeaderForReceipt: (params: HeaderReceiptParams): string => {
        return `
        <div class="receipt-header">
          <h1>${params.doctorName || "Dr. Sample"}</h1>
          <h2>${params.clinicName || "Sample Clinic"}</h2>
          <p>${params.headerText || "Sample Header Text"}</p>
          <p>${params.clinicAddress || "Sample Address"}</p>
        </div>
      `;
      },

      getFooterForReceipt: (params: FooterReceiptParams): string => {
        return `
        <div class="receipt-footer">
          <p>Thank you for visiting!</p>
          <p>Generated on: ${new Date().toLocaleDateString()}</p>
          <p>Receipt ID: ${params.data?.receipt_id || "SAMPLE123"}</p>
        </div>
      `;
      },

      getBodyForReceipt: (params: BodyReceiptParams): string => {
        return `
        <div class="receipt-body">
          <h3>Receipt Details</h3>
          <p><strong>Patient:</strong> ${params.data.name || "Sample Patient"}</p>
          <p><strong>UHID:</strong> ${params.data.uhid || "SAMPLE123"}</p>
          <p><strong>Visit Date:</strong> ${params.data.visit_date || new Date().toLocaleDateString()}</p>
          <p><strong>Amount:</strong> ₹${params.data.receipt_amount || "0"}</p>
          <p><strong>Receipt Number:</strong> ${params.data.receipt_number || "RCP001"}</p>
          <p><strong>Payment Status:</strong> ${params.data.payment_status || "PAID"}</p>
          <div class="receipt-items">
            <h4>Services:</h4>
            ${
              params.data.receipt_sku
                ?.map(
                  (sku) => `
              <div class="sku-item">
                <span>${sku.sku_item?.service_name || "Service"}</span>
                <span>₹${sku.sku_item?.price || "0"}</span>
              </div>
            `
                )
                .join("") || "<p>No services listed</p>"
            }
          </div>
        </div>
      `;
      },

      getBodyForPaymentNoteForReceipt: (params: BodyReceiptParams): string => {
        return `
        <div class="payment-note-body">
          <h3>Payment Receipt</h3>
          <p><strong>Patient:</strong> ${params.data.name || "Sample Patient"}</p>
          <p><strong>UHID:</strong> ${params.data.uhid || "SAMPLE123"}</p>
          <p><strong>Payment Date:</strong> ${params.data.visit_date || new Date().toLocaleDateString()}</p>
          <p><strong>Amount Paid:</strong> ₹${params.data.receipt_amount || "0"}</p>
          <p><strong>Payment Method:</strong> ${params.data.receipt_payment?.[0]?.paymode || "CASH"}</p>
          <p><strong>Transaction ID:</strong> ${params.data.ref_trx_id || "TXN123"}</p>
          <p><strong>Outstanding Balance:</strong> ₹${params.data.amount_due || "0"}</p>
        </div>
      `;
      },

      getPatientIntroForReceipt: (
        params: PatientIntroReceiptParams
      ): string => {
        return `
        <div class="patient-intro">
          <h3>Patient Information</h3>
          <p><strong>Name:</strong> ${params.patientInfo.name || "Sample Patient"}</p>
          <p><strong>UHID:</strong> ${params.patientInfo.uhid || "SAMPLE123"}</p>
          <p><strong>Gender:</strong> ${params.patientInfo.gender || "Not specified"}</p>
          <p><strong>Age:</strong> ${params.patientInfo.age || "Not specified"} years</p>
          <p><strong>Visit Date:</strong> ${params.appointmentInfo.visit_date || new Date().toLocaleDateString()}</p>
        </div>
      `;
      },

      getPdfCssForReceipt: (customCss?: any): string => {
        return `
        <style>
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 20px;
            line-height: 1.6;
          }
          .receipt-header {
            text-align: center;
            border-bottom: 2px solid #333;
            padding-bottom: 20px;
            margin-bottom: 20px;
          }
          .receipt-header h1 {
            margin: 0;
            font-size: 24px;
            color: #333;
          }
          .receipt-header h2 {
            margin: 5px 0;
            font-size: 18px;
            color: #666;
          }
          .receipt-body {
            margin: 20px 0;
          }
          .receipt-items {
            margin-top: 15px;
          }
          .sku-item {
            display: flex;
            justify-content: space-between;
            padding: 5px 0;
            border-bottom: 1px solid #eee;
          }
          .receipt-footer {
            text-align: center;
            border-top: 2px solid #333;
            padding-top: 20px;
            margin-top: 20px;
            font-size: 12px;
            color: #666;
          }
          .patient-intro {
            background-color: #f9f9f9;
            padding: 15px;
            margin: 10px 0;
            border-radius: 5px;
          }
          .payment-note-body {
            background-color: #fff3cd;
            padding: 15px;
            border: 1px solid #ffeaa7;
            border-radius: 5px;
          }
          ${customCss || ""}
        </style>
      `;
      },

      getDefaultPdfConfigForReceipt: (): TGetReceiptPdfConfig => {
        return {
          doctor_oid: "sample_doctor",
          clinic_id: "sample_clinic",
          page_size: "A4",
          margins: {
            top: 1.0,
            bottom: 1.0,
            left: 1.0,
            right: 1.0,
          },
          heights: {
            header: 2.5,
            footer: 2.0,
          },
          flags: {
            print_header: true,
            print_footer: true,
            print_uhid: true,
            print_receipt_number: true,
            discount_column: "IF_APL",
            quantity_column: "IF_APL",
            print_paymode_split: true,
            print_transaction_id: true,
            date_and_time: DateAndTimeConfigForReceipt.DATE_ONLY,
            print_amount_in_words: false,
            bill_created_at: false,
          },
        };
      },
    },
    opdslip: {
      getHeadCssForOpdSlip(config: TGetReceiptPdfConfig): string {
        return ` <style> body { } </style> `;
      },
      getHeaderForOpdSlip: (data: {
        doctorName: string;
        headerText: string;
        clinicName: string;
        clinicAddress: string;
        config: TGetReceiptPdfConfig;
      }): string => {
        return `<div class="opd-slip-header"><h1>${data.doctorName}</h1><p>${data.clinicName}</p></div>`;
      },
      getPatientDetails: (data: {
        name: string;
        age?: number;
        gender?: string;
        uhid?: string;
      }): string => {
        return [
          data.name ? `<b>Patient Name:</b> ${data.name}` : undefined,
          data.age ? `<b>Age:</b> ${data.age}` : undefined,
          data.gender ? `<b>Gender:</b> ${data.gender}` : undefined,
          data.uhid ? `<b>UHID:</b> ${data.uhid}` : undefined,
        ]
          .filter(Boolean)
          .join(" | ");
      },
      getBodyForOpdSlip: (data: {
        name: string;
        age?: string;
        gender?: string;
        uhid?: string;
        time?: string;
        date?: string;
        doctor_name?: string;
        token?: string;
        patient_mobile?: string;
        services: { service_name: string; service_id: string; price: number }[];
        payment_status?: string;
      }): string => {
        return `<main><p>${data.name}</p><p>Services: ${data.services.length}</p></main>`;
      },
      getFooterForOpdSlip: (data: {
        created_by?: string;
        created_at?: string;
      }): string => {
        return `<footer><p>valid only for this visit${data.created_by ? ` | Created By: ${data.created_by}` : ""}${data.created_at ? ` | Created At: ${data.created_at}` : ""}</p></footer>`;
      },
    },
  };

  pushGenieToBE = async (data: string[]): Promise<void> => {
    console.log("called to push data to BE", data);
  };
}

export default DummyBridge;
